"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassSortingTypes = void 0;
var ClassSortingTypes;
(function (ClassSortingTypes) {
    ClassSortingTypes["NameAsc"] = "ClassOrderByNameAsc";
    ClassSortingTypes["NameDesc"] = "ClassOrderByNameDesc";
    ClassSortingTypes["DateAsc"] = "ClassOrderByCreationDateAsc";
    ClassSortingTypes["DateDesc"] = "ClassOrderByCreationDateDesc";
})(ClassSortingTypes || (exports.ClassSortingTypes = ClassSortingTypes = {}));
